import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { IconDetailComponent, IconDetailModel } from '../../../common/icon-detail/icon-detail.component';
import { StatusIndicatorComponent } from '../../../common/status-indicator/status-indicator.component';
import { UserGroup } from '../../../domain/models/user-group.model';
import { UserGroupListDataSource } from './user-group-list-.datasourse';
import { CustomDialogFactory } from '../../../domain/services/dialog/custom-dialog.factory';
import { UserGroupServiceService } from '../../../domain/services/user-group/user-group.service.service';
import { Icons } from '../../../domain/enums/icons-enums';
import { DialogTypeEnum } from '../../../domain/enums/dialog-type.enum';
import { DialogService } from '../../../domain/services/dialog/dialog.service';
import { AuthenticationService } from '../../../domain/services/auth/authentication.service';

@Component({
  selector: 'app-user-group-list',
  standalone: true,
  imports: [
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonToggleModule,
    FormsModule,
    MatPaginatorModule,
    RouterModule,
    MatTableModule,
    MatInputModule,
    MatSortModule,
    MatSelectModule,
    CommonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatTooltipModule,
    IconDetailComponent
],
  templateUrl: './user-group-list.component.html',
  styleUrl: './user-group-list.component.css'
})
export class UserGroupListComponent implements OnInit, AfterViewInit{

constructor(private readonly auth: AuthenticationService, private readonly service: UserGroupServiceService, private readonly dialog: CustomDialogFactory, private readonly dialogService: DialogService) {
    }
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    @ViewChild(MatTable) table!: MatTable<UserGroup>;
      icons = Icons
    query = "";
    dataSource = new UserGroupListDataSource([]);
    displayedColumns = [ 'groupName', 'createdAt','createdBy', 'members', 'actions'];
    userModel: IconDetailModel | undefined;
    userGroups : UserGroup [] = [];
    userId: Number = 0;
      ngOnInit(): void {
         const currentUser = this.auth.getCurrentUser();
    this.userId = currentUser?.id ?  Number.parseInt(currentUser?.id??0) : 0;
     this.service.getCount().subscribe(value => {
        this.userModel = { icon: Icons.PersonPinIcon, label: 'Total Groups', value: value.toString() , hideVerticalLine: true};
      });
   
  }
  
  ngAfterViewInit(): void {
      this.service.getAll().subscribe(value => {
      this.userGroups = value; 
      
      this.rebuildDataSource(value);
    });
  }
    rebuildDataSource(data: UserGroup[]) {
      this.dataSource = new UserGroupListDataSource(data); 
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.table.dataSource = this.dataSource;
    }
  onSearch() {
    this.paginator.pageIndex = 0; //reset paginator on search
    if (this.query.length > 2) {
      const data = this.userGroups.filter(value =>
       value.groupName.toLowerCase().includes(this.query.toLowerCase())
      );
  
      this.rebuildDataSource(data);
    } 
  }
onRowClicked(row: any): void {
    console.log('Row clicked: ', row);
    // Perform navigation, open dialog, etc.
  }
  deleteUserGroup(group: UserGroup): void {
    // Same confirm-then-delete pattern as manage-user-group.component.ts's deleteGroup()
    // and users-list.component.ts's removeUser() elsewhere in this app.
    this.dialogService.openDeletedDialog(
      "Are you sure you want to delete this user group from the platform ?",
      "Once you confirm this action, this can’t be undone.",
      (confirmed: boolean) => {
        if (confirmed) {
          this.service.deleteGroup(group.id).subscribe(() => {
            this.userGroups = this.userGroups.filter(g => g.id !== group.id);
            this.rebuildDataSource(this.userGroups);
          });
        }
      }
    );
  }
  addNewUserGroup(){
      let data: UserGroup = {
        id: 0,//827 932 583
        groupName: '',
        createAt: new Date(),
        createdBy: '',
        members: 0,
        description: '',
        userId: 0
      };
      this.dialog.openDialog(DialogTypeEnum.NEW_USER_GROUP, {}, (data: UserGroup) => {
        console.log(this.auth.getCurrentUser());
        data.userId = Number.parseInt(this.auth.getCurrentUser()?.id?? '0') ;
        this.service.create(data).subscribe(value => {
          this.service.getAll().subscribe(value => {
            this.userGroups = value; 
            
            this.rebuildDataSource(value);
          });
        });
         });
    }
}
